import React, {useEffect, useState} from "react";
import Button from "../../../components/button";
import Breadcrumbs from "../../../components/breadcrumbs";
import Input from "../../../components/input";
import {ToastContainer, toast} from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import {useDispatch, useSelector} from "react-redux";
import {Link, useHistory} from "react-router-dom";
import {
    createSociety,
    CREATE_SOCIETY,
    clear_societies,
    getAllSocieties
} from "../../../redux/societies";
import Footer from "../../../components/footer";

const CreateSociety = () => {
    const dispatch = useDispatch();
    let history = useHistory();
    const _create_society = useSelector(
        (state) => state.societies_module._create_society
    );
    const {token} = useSelector((state) => state.users_module.login.data) || null;

    const [form, setForm] = useState({
        nombre: "",
    });

    useEffect(() => {
        if (_create_society.status === 201) {
            dispatch(clear_societies(CREATE_SOCIETY));
            history.push("/sociedades");
            dispatch(getAllSocieties(token));
        } else if (_create_society.status !== 0) {
            dispatch(clear_societies(CREATE_SOCIETY));
            toast.error(_create_society.message, {position: toast.POSITION.TOP_RIGHT});
        }
    }, [_create_society, dispatch, history, token]);

    const handleChange = (e) => {
        setForm({
            ...form,
            [e.target.name]: e.target.value,
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        //validate fields
        if (form.nombre === "") {
            toast.error("Debe ingresar el nombre", {position: toast.POSITION.TOP_RIGHT});
            return;
        }

        dispatch(createSociety(token, form));
    };

    return (
        <div className="app-content content">
            <div className="content-overlay"/>

            <div className="content-wrapper">
                <div className="content-header row">
                    <div className="content-header-left col-12 mb-2 mt-3">
                        <Breadcrumbs
                            title="Sociedad"
                            items={[
                                {label: "Lista de sociedades", link: "/Sociedades"},
                            ]}
                        />
                    </div>
                </div>
                <div className="content-body">
                    <div className="row">
                        <div className="col-12">
                            <form className="card" onSubmit={handleSubmit}>
                                <div className="card-header">
                                    <h4 className="card-title">Crear Sociedad</h4>
                                </div>
                                <div className="card-body">
                                    <div><ToastContainer/></div>
                                    <div className="row">
                                        <div className=" col-md-12">
                                            <Input
                                                name="nombre"
                                                label="Nombre"
                                                value={form.nombre}
                                                onChange={handleChange}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="card-footer d-flex justify-content-end">
                                    <Link to="/sociedades" className="btn btn-outline-dark m-1">
                                        Cancelar
                                    </Link>
                                    <Button type="submit" text="Crear" theme="calendar" classes="m-1"/>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <Footer/>
        </div>
    );
};

export default CreateSociety;
